import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useLearnerStyleQuestions from 'components/Common/LearnerStyleQuestions/Hooks/useLearnerStyleQuestions';
import { useContext as useUsersContext } from 'components/Users/Context';

export default function MyStyle() {
  const learnerStyleQuestions = useLearnerStyleQuestions();

  const { state: stateUsers } = useUsersContext();
  const member = stateUsers.user?.attributes?.specific;

  if (!member || !learnerStyleQuestions) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="py-3">
      {learnerStyleQuestions.map((learnerStyleQuestion) => (
        <div
          key={learnerStyleQuestion.id}
          className="my-3 p-3 border"
        >
          <Row className="align-items-center">
            <Col md={6} className="fw-semibold">
              {learnerStyleQuestion.attributes.title}
            </Col>

            <Col md={6}>
              {learnerStyleQuestion.attributes[`answer${(member.learning_style || {})[learnerStyleQuestion.id]}`]}
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
}
